import { requestTimer } from './requestTimer';
import { notifyError } from 'utils/notifications';
import i18n from 'i18next';

export const API_PATH = process.env.REACT_APP_API_PATH ?? '/api/external';

// credentials: isTestingMode ? 'include' : 'same-origin' can be used for testing on separate origins
const defaultRequestOptions = () => ({
  headers: new Headers({
    'Content-Type': 'application/json',
  }),
});

export const fetchFromApi = async (
  path,
  options = defaultRequestOptions(),
  handleResponse = handleApiResponse
) => {
  const endTimer = requestTimer(
    i18n.t('datagate.external.message.requestIsBeingProcessed')
  );

  try {
    const response = await fetch(`${API_PATH}${path}`, {
      ...options,
    });
    endTimer();
    return await handleResponse(response);
  } catch (error) {
    endTimer();
    throw error;
  }
};

export const handleApiResponse = async response => {
  const string = await response.text();
  const json = string === '' ? {} : JSON.parse(string);

  if (response.status === 401) handleUnauthorized();

  return response.ok ? json : Promise.reject(json);
};

export const handleFileResponse = async response => {
  const blob = await response.blob();

  if (response.status === 401) handleUnauthorized();

  return response.ok ? blob : Promise.reject(response);
};

export const optionsForPostRequest = data => ({
  ...defaultRequestOptions(),
  method: 'POST',
  body: JSON.stringify(data),
});

export const optionsForDeleteRequest = data => ({
  ...defaultRequestOptions(),
  method: 'DELETE',
  body: JSON.stringify(data),
});

export const optionsForPutRequest = data => ({
  ...defaultRequestOptions(),
  method: 'PUT',
  body: JSON.stringify(data),
});

export const optionsForPatchRequest = data => ({
  ...defaultRequestOptions(),
  method: 'PATCH',
  ...(data && { body: JSON.stringify(data) }),
});

export const optionsForFileRequest = data => ({
  headers: new Headers({
  }),
  method: 'POST',
  body: data,
});

export const notifyApiError = (i18n, err) =>
  notifyError(i18n.t(err.key ?? err.code) || i18n.t('datagate.external.global.genericError'), { killer: true });

export const handleLogout = async response => {
  const res = await response;
  handleUnauthorized(response);
  handleRedirect(res);
};

const handleUnauthorized = (response) => {
  if (response.status === 401) {
    localStorage.removeItem('authenticated');
    localStorage.removeItem('expiresAt');
    window.location.pathname = process.env.PUBLIC_URL;
  }
}

const handleRedirect = res => {
  localStorage.removeItem('authenticated');
  localStorage.removeItem('expiresAt');
  window.location.href = res.url;
};
